import "./FloatingButtons.css";

import {
    FaPhoneAlt,
    FaWhatsapp
} from "react-icons/fa";


export default function FloatingButtons() {

    return (

        <div className="floating-buttons">
            <a
                href="tel:+916382282058"
                className="call-btn"
                title="Call Us"
            >

                <FaPhoneAlt />

            </a>


            <a
                href="https://wa.me/6382282058"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-btn"
                title="WhatsApp"
            >

                <FaWhatsapp />

            </a>



        </div>

    )

}